import { render, staticRenderFns } from "./LiveShare.vue?vue&type=template&id=0f25068f&"
import script from "./LiveShare.vue?vue&type=script&lang=js&"
export * from "./LiveShare.vue?vue&type=script&lang=js&"
import style0 from "./LiveShare.vue?vue&type=style&index=0&id=0f25068f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports